import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Button,
  CardTitle,
  Col,
  Form,
  Label,
  Row,
  Container,
  Card,
  CardBody,
  Spinner, Modal, ModalHeader, ModalBody, Nav, NavItem, NavLink,
} from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../api"
import { withTranslation } from "react-i18next"
import Select from "react-select"
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator"
import {Link} from "react-router-dom";
import FileDownload from "js-file-download";
import Affectation from "./Affectation";
import classnames from "classnames";
import FicheVoeuxSurveillance from "./FicheVoeuxSurveillance";
const FicheVoeuxSurveillanceSem = props => {
  const [section, setSection] = useState("")
  const [semestre, setSemestre] = useState([
    {value: 1, label: "Semestre 1", section: 0},
    {value: 2, label: "Semestre 2", section: 1},
    {value: 3, label: "Session de contrôle", section: 2},
  ])


  const renderBlock = section => {
    for (let i = 0; i < semestre.length; i++) {
      if (section === i) {
        return <FicheVoeuxSurveillance semestre={semestre[i]}/>
      }
    }
  }

  return (
      <React.Fragment>

        <Container fluid>
          <Card>
            <CardBody>
              <Nav className="icon-tab nav-justified">
                {semestre.map((element, index) => (
                    <NavItem key={index}>
                      <NavLink
                          style={{cursor: "pointer"}}
                          className={classnames({
                            active: section === element.section,
                          })}
                          onClick={() => {
                            setSection(element.section)
                          }}
                      >
                        <span className="d-none d-sm-block">{element.label}</span>
                      </NavLink>
                    </NavItem>
                ))}
              </Nav>
              {renderBlock(section)}
            </CardBody>
          </Card>
        </Container>

      </React.Fragment>
  )
}

export default withTranslation()(FicheVoeuxSurveillanceSem)
FicheVoeuxSurveillanceSem.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
}
